import PromotionPlanningGrid from "./PromotionPlanningGrid";

const PromotionPlanningTab = () => {
    return (
        <div className="container-fluid">
            <PromotionPlanningGrid 
                gridHeight="70vh"
            />
        </div>
    );
};

export default PromotionPlanningTab;
